import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getProposals = createSelector(
    getModel,
    (model) => model.proposals,
);

export const getIsFetchingProposals = createSelector(
    getProposals,
    (value) => value.isFetching,
);

export const getProposalsData = createSelector(
    getProposals,
    (value) => value.data,
);

export const getProposalsErrors = createSelector(
    getProposals,
    (value) => value.errors,
);

export const getDeleteProposal = createSelector(
    getModel,
    (model) => model.deleteProposal,
);

export const getDeleteProposalErrors = createSelector(
    getDeleteProposal,
    (deleteProposal) => deleteProposal.errors || [],
);

export const getIsOpenProposalModal = createSelector(
    getModel,
    (model) => model.isOpenProposalModal,
);

export const getShowEmptyState = createSelector(
    getModel,
    (model) => model.showEmptyState,
);
